var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { space } from "../../tokens/space";
import { containerWidth } from "../../tokens/size";
const getContainerStyles = (maxWidth) => {
    const applyPaddingWidth = maxWidth + 50;
    return {
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: maxWidth,
        marginInline: 'auto',
        [`@media (max-width: ${applyPaddingWidth}px)`]: {
            paddingLeft: space.containerOuterPadding,
            paddingRight: space.containerOuterPadding,
        },
    };
};
function ContainerComponent(_a, ref) {
    var { children, className, maxWidth = containerWidth.md, component } = _a, other = __rest(_a, ["children", "className", "maxWidth", "component"]);
    const Component = component || 'div';
    const numericMaxWidth = typeof maxWidth === 'string' ? parseInt(maxWidth) : maxWidth;
    return (_jsx(Component, Object.assign({ ref: ref, css: getContainerStyles(numericMaxWidth), className: className }, other, { children: children })));
}
/**
 * A component used to center content with padding and max-width
 *
 * @example
 * <Container>
 *     <div>Content</div>
 * </Container>
 *
 */
export const Container = React.forwardRef(ContainerComponent);
